// extracted by mini-css-extract-plugin
export var label = "fp-dx";
export var labelDark = "fp-ex";
export var labelDisabled = "fp-fx";
export var label__display = "fp-gx";
export var label__tooltipIcon = "fp-hx";
export var label__tooltipIconDark = "fp-ix";
export var mt0 = "fp-6w";
export var mt1 = "fp-7w";
export var mt2 = "fp-8w";
export var mt3 = "fp-9w";
export var mt4 = "fp-ax";
export var mt5 = "fp-bx";
export var mt6 = "fp-cx";
export var wrapper = "fp-jx";